// Utility functions for route paths in Next.js
export const paths = {
    home: '/',
    about: '/about',
    research: '/research',
    researchArticle: '/research/:id',
    researchPolicy: '/research/policy',
    researchEducation: '/research/education',
    researchCategoryArticle: '/research/:category/:id',
    news: '/news',
    newsArticle: '/news/:id',
    newsNotices: '/news/notices',
    newsDecisions: '/news/decisions',
    newsResearch: '/news/research',
    newsCategoryArticle: '/news/:category/:id',
    policies: '/policies',
    policy: '/policies/:id',
    skills: '/skills',
    skill: '/skills/:id',
    certificates: '/certificates',
    certificateResult: '/certificateResult',
    contact: '/contact',
    search: '/search',
}; 